/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type MeasurementUnit = "CM" | "IN" | "%future added value";
export type SbSharedMeasurementUnitProvider_user$ref = any;
export type SbSharedMeasurementUnitProvider_user = {
    readonly profile: {
        readonly measurementUnit: MeasurementUnit | null;
    } | null;
    readonly " $refType": SbSharedMeasurementUnitProvider_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedMeasurementUnitProvider_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "measurementUnit",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '5c2bb3a900c1e1289a6ed19186e53895';
export default node;
